// src/components/ChooseUsernameStepComponent.js
import React from 'react';

export default function ChooseUsernameStep({
                                               muultiName,
                                               onChange,
                                               onSubmit,
                                               error
                                           }) {
    return (
        <div className="muulti-container" id="step-2-container">
            <h2>Pick Your MuultiSpace Name</h2>
            <form onSubmit={onSubmit}>
                <input
                    type="text"
                    value={muultiName}
                    onChange={e => onChange(e.target.value)}
                    placeholder="Username"
                    className="muulti-input"
                    required
                    pattern="[A-Za-z0-9_-]+"
                    title="Only letters, numbers, underscores (_) and dashes (-) are allowed"
                />
                <ul>
                    <li>3–20 characters</li>
                    <li>Only letters, numbers, underscores and dashes</li>
                    <li>Must be unique</li>
                </ul>
                <button type="submit" className="muulti-button">
                    Save &amp; Sign
                </button>
            </form>
            {error && <p className="error">{error}</p>}
        </div>
    );
}
